import alt from 'components/Dispatcher';
import {browserHistory} from 'react-router';
import API from 'sources/API';

class UserActions {
    // 设置 loading
    setLoading(obj) {
        return obj;
    }
    // 获取验证码
    fetchCaptcha() {
        return true;
    }
    // 登录
    login(email, password) {
        return { email: email, password: password };
    }
    // 找回密码
    forget(email, captcha) {
        return { email: email, captcha: captcha };
    }
    // 注册
    regist(email, password, captcha) {
        return { email: email, password: password, captcha: captcha };
    }
    // 根据id获取用户信息
    fetchUser(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户的id
        }
    }
    // 更新当前user信息
    updateUser(user) {
        return user;
    }
    // 更新token
    updateToken(token) {
        if(token) {
            localStorage.setItem('accessToken', token);
            document.cookie = `accessToken=${token}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
        } else { // logout
            localStorage.removeItem('accessToken');
            document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        }
        return token;
    }
    // 更新报错信息
    updateErrMsg(errMsg) {
        return errMsg;
    }
    // 获取用户信息成功
    fetchUserSuccess(json) {
        if (json.status === 0) {
            if(json.userInfo) {
                this.updateUser(json.userInfo);
            } else {
                this.updateUser(json.result);
            }
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    // 获取失败
    fetchFailed(json) {
        console.log(json);
        if(json.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }else{
            if(json.msg){
                this.updateErrMsg(json.msg)
            }
        }
        return json;
    }
    // 登录成功
    loginSuccess(data) {
        this.updateErrMsg(data.msg);
        if (data.status === 0) {
            this.updateUser(data.result);
            this.updateToken(data.accessToken);
            browserHistory.push('/profile');
        }
        return data;
    }
    // 登录／注册失败
    loginFailed(res) {
        if (res.msg) {
            this.updateErrMsg(res.msg);
        }
        console.log(res);
        return res;
    }
    // 注册成功
    registSuccess(data) {
        if (data.msg) {
            this.updateErrMsg(data.msg);
        }
        browserHistory.push('/login');
        return data;
    }
    // 找回密码成功
    forgetSuccess(data) {
        if (data.msg) {
            this.updateErrMsg(data.msg);
        }
        if(data.status === 0) {
            browserHistory.push('/login');
        }
        return data;
    }
    // 更新验证码
    updateCaptcha(captcha) {
        return captcha;
    }
    // 获取验证码成功
    fetchCaptchaSuccess(res) {
        res.blob.then(myBlob=>{
            let objectURL = URL.createObjectURL(myBlob);
            this.updateCaptcha({captchaKey: res.key, captchaImg: objectURL});
        })
        return res;
    }
    // post用户信息
    postUserInfo(userInfo) {
        return userInfo;
    }
    // post用户信息成功
    postUserSuccess(res) {
        if(res.status === 0) {
            browserHistory.push('/profile');
        } else {
            this.fetchFailed(res);
        }
        return res;
    }

    // 获取登录用户已付费的Medias
    fetchPaidMedias(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchPaidMediasSuccess(json) {
        if(json.status === 0) {
            this.updatePaidMedias(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updatePaidMedias(medias) {
        return medias;
    }

    // 获取登录用户发布的Medias
    fetchPublishMedias(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchPublishMediasSuccess(json) {
        if(json.status === 0) {
            this.updatePublishMedias(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updatePublishMedias(medias) {
        return medias;
    }
    // 获取登录用户收藏的Medias
    fetchCollectMedias(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchCollectMediasSuccess(json) {
        if(json.status === 0) {
            this.updateCollectMedias(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updateCollectMedias(medias) {
        return medias;
    }
    // 获取登录用户发布的Albums
    fetchPublishAlbums(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchPublishAlbumsSuccess(json) {
        if(json.status === 0) {
            this.updatePublishAlbums(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updatePublishAlbums(albums) {
        return albums;
    }
    // 获取登录用户收藏的Albums
    fetchCollectAlbums(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchCollectAlbumsSuccess(json) {
        if(json.status === 0) {
            this.updateCollectAlbums(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updateCollectAlbums(medias) {
        return medias;
    }
    // 获取我关注的用户
    fetchFollowing(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchWants(id) {
        if(id) {
            return id;
        } else {
            return null;
        }
    }
    fetchLinks(id) {
        if(id){
            return id;
        }else {
            return null;
        }
    }
    // 获取关注我的用户
    fetchFollowed(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchFollowingSuccess(json) {
        if(json.status === 0) {
            this.updateFollowing(json.result);
        } else {
            this.fetchFailed(json);
        }
        return false;
    }
    fetchWantsSuccess(json){
        if(json.status === 0) {
            this.updateWants(json.result);
        }else{
            this.fetchFailed(json);
        }
        return false;
    }
    fetchLinksSuccess(json){
        if(json.status === 0) {
            this.updateLinks(json.result);
        }else{
            this.fetchFailed(json);
        }
        return false;
    }
    fetchFollowedSuccess(json) {
        if(json.status === 0) {
            this.updateFollowed(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;
    }
    updateFollowing(following) {
        return following;
    }
    updateWants(wants){
        return wants;
    }
    updateLinks(links){
        return links;
    }
    updateFollowed(followed) {
        return followed;
    }
    postFollow(type) {
        return type;
    }
    postFollowSuccess(json) {
        if(json.status === 0) {
            this.updateUserFollowing(true);
        } else {
            this.fetchFailed(json);
        }
        return false;
    }
    postUnfollowSuccess(json) {
        if(json.status === 0) {
            this.updateUserFollowing(false);
        } else {
            this.fetchFailed(json);
        }
        return false;
    }
    updateUserFollowing(val) {
        return val;
    }
    clearFollowing() {
        return true;
    }
    clearWants(){
        return true;
    }
    clearLinks(){
        return true;
    }
    clearFollowed() {
        return true;
    }
    clearData(key) {
        return key;
    }
    fetchAgent(id) {
        if(id) {
            return id;
        } else {
            return null;  //id为空时获取当前登录用户
        }
    }
    fetchAgentArticles() {
        return true;
    }
    updateAgent(agent) {
        return agent;
    }
    updateAgentArticles(articles){
        return articles;
    }
    clearArticles(){
        return true;
    }
    postAgent(agent){
        return agent;
    }
    updateError(err){
        return err;
    }
    clearError(){
        return true;
    }
    postAgentSuccess(json){
        if(json.status === 0){
            this.updateAgent(json.result)
            browserHistory.push(`/agent/${json.result.agent_id}`)
        }else{
            this.fetchFailed(json);
        }
        return json;
    }
    fetchAgentArticlesSuccess(json) {
        if(json.status === 0) {
            this.updateAgentArticles(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json; 
    }
    fetchAgentSuccess(json) {
        if(json.status === 0) {
            this.updateAgent(json.result);
        } else {
            this.fetchFailed(json);
        }
        return json;    
    }
}

export default alt.createActions(UserActions);


// WEBPACK FOOTER //
// ./src/actions/UserActions.js